import { REQUIRED_TENANT_ENV_KEYS, readTenantEnv } from './env';

/** D7 fail-closed check for one tenant — returns the missing key NAMES only, never their values. */
export const getMissingTenantEnvKeys = (slug: string): string[] =>
  REQUIRED_TENANT_ENV_KEYS.filter(key => !readTenantEnv(slug, key));
